import React from 'react';
import {Link} from 'react-router'

var Login = React.createClass({
  getInitialState: function(){
    return{
      userName : "",
      password : "",
      userNameErrMsg: "",
      passwordErrMsg: "",
      userErrorclass: "",
      passwordErrorclass: ""
    }
  },
  componentDidMount: function(){
    if(this.props.signUpPopup.slug !== null && this.props.signUpPopup.slug !== "undefined/undefined" && this.props.signUpPopup.slug !== undefined){
      if(this.props.signUpPopup.slug.split("/")[0] !== "anonymous"){
        this.setState({userName: this.props.signUpPopup.slug.split("/")[0]});
      }
    }
  },
  componentWillReceiveProps: function(nextProps){
    if(nextProps.signInError){
      this.setState({ userErrorclass: "field__error--input", 
                      passwordErrorclass: "field__error--input",
                      userNameErrMsg: "Error: Username and Password do not match.",
                      passwordErrMsg: ""
                    });
    } else {
      this.setState({userErrorclass: "", passwordErrorclass: "", userNameErrMsg: "", passwordErrMsg: ""});
    }
  },
  handleLoginClick: function(){
    if(this.state.userName.trim() === "" && this.state.password.trim() === ""){
      this.setState({ userErrorclass: "field__error--input",
                      passwordErrorclass:  "field__error--input",
                      userNameErrMsg: "Error:  Please enter your Username",
                      passwordErrMsg: "Error:  Please enter your Password" 
                    });
    } else if (this.state.userName.trim() === ""){
      this.setState({userErrorclass: "field__error--input", userNameErrMsg: "Error:  Please enter your Username"});   
    } else if (this.state.password.trim() === ""){
      this.setState({passwordErrorclass: "field__error--input", passwordErrMsg: "Error:  Please enter your Password"});
    } else {
      this.props.loginClick(this.state.userName, this.state.password);
    }
  },
  userNameChange: function(e){
    this.setState({userName: e.target.value, userErrorclass: "", userNameErrMsg: ""});
    if(this.props.signInError) this.props.clearLoginErrors();
  },
  passwordChange: function(e){
    this.setState({password: e.target.value, passwordErrorclass: "", passwordErrMsg: ""});
    if(this.props.signInError) this.props.clearLoginErrors();
  },
  handleForgotPasswordClick: function(){
    this.props.forgotPassword();
  },
  render: function(){
    return (
      <div className="form__wrap--col form__wrap--col-left">
        <div className="form__row clearfix">
          <h4 className="modal__header--title big">Login to Your Blended Account</h4>
        </div>
        <div className="form__row clearfix">
          <div className="form__cell">
           {this.state.userNameErrMsg !== "" ?
            <p className="field__error--text">{this.state.userNameErrMsg}</p> : null }
            <div className={this.state.userErrorclass}>
              <input type="text" onChange = {this.userNameChange} value={this.state.userName} placeholder="Username"/>
            </div>
          </div>
        </div>
        <div className="form__row clearfix">
          <div className="form__cell">
            {this.state.passwordErrMsg !== "" ?
            <p className="field__error--text">{this.state.passwordErrMsg}</p> : null }
            <div className={this.state.passwordErrorclass}>
              <input type="password" autoFocus onChange = {this.passwordChange} value={this.state.password} placeholder="Password"/>
            </div>
          </div>
        </div>
        <div className="form__row clearfix">
        <div className="form__cell">
          <button className="btn__lg bg-dark sign_up_btn" onClick = {this.handleLoginClick}><span>Login</span></button>
          <p className="top--ten">
            <a href="javascript:void(0)" onClick = {this.handleForgotPasswordClick}>Forgot your password?</a>
          </p>
          </div>
        </div>
        <div className="form__row last clearfix">
          <div className="blended__logo-box"> 
            <img className="blended__logo-box--icon img-responsive" src="images/blended-logo-icon.png" local/> 
          </div>
        </div>
      </div>
     
    );
  }
});

export {Login}


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/SignUpPopup/Login.jsx
 **/